<template>
	<!-- Main section start -->
	<section class="h-screen px-12 lg:px-32 py-32 mb-8">
		<div class="w-full md:w-1/2 h-full flex flex-col md:justify-center mt-16">
			<!-- Main text start -->
			<h1 class="uppercase text-5xl xl:text-7xl mb-4 greeting">
				{{ $t('main.welcome') }}
				<span class="companyName"><strong>Virtus Consulting!</strong></span>
			</h1>
			<p class="xl:w-1/2 text-stone-500 text-justify description">
				{{ $t('main.provide') }} 
				<br><br>{{ $t('main.understand') }}  
				<br><br>{{ $t('main.donthesitate') }}
			</p>
			<br>
			<!-- Main text end -->
		
		<!-- "Contact us" button start -->	
		<a href="#contact-section" class="btn contact py-4 px-8 text-lg" role="menuitem">
            {{ $t('main.contactUs') }}
        </a>
		<!-- "Contact us" button ends -->	
		</div>

		<!-- Lawyer image start -->
		<div class="absolute bottom-0 right-0 overflow-hidden h-2/5 sm:h-1/2 md:h-3/5 lg:h-4/6 -z-50">
			<img src="@/assets/logo_only.svg" alt="img" class="h-full opacity-40">
		</div>

		<!-- Lawyer image end -->


		<!-- "More" button start -->
		<div class="w-full h-20 flex justify-start md:justify-center items-center">
			<a href="#about-section">
				<i
					class="fa-solid fa-arrow-down transition text-stone-100 text-xl bg-[#132e63] rounded-full shadow p-4 hover:-translate-y-2 hover:shadow-xl opacity-40"></i>
			</a>
		</div>
		<!-- "More" button end -->

	</section>
	<!-- Main section end -->
</template>

<script>
export default {

}
</script>

<style>
.greeting {
	color: #051328 !important;
}
.companyName {
	color: #051328 !important;
}
.description {
	color: #051328 !important;
}

.contact {
    background-color: #132e63 !important;
    color: #f5f5f5;
    border-radius: 0.375rem; /* Rounded corners */
    text-align: center; /* Center text */
    display: block; 
	font-weight: bold;
}
</style>